/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/scandipwa
 */

import { lazy, Suspense } from 'react';

import { SearchField as SourceSearchField } from 'SourceComponent/SearchField/SearchField.component';
import { scrollToTop } from 'Util/Browser';
import history from 'Util/History';
import { appendWithStoreCode, objectToUri } from 'Util/Url';

import './SearchField.style';

export const SearchOverlay = lazy(() => import('Component/SearchOverlay'));

/** @namespace Pwa/Component/SearchField/Component */
export class SearchField extends SourceSearchField {
    getLinkTo() {
        const {
            searchResults
        } = this.props;

        const product = searchResults?.length > 0 ? searchResults?.[0] : {};
        const { url, parent_product: { parent_url } = {}, attributes = {} } = product;

        if (!url) {
            return {};
        }
        const search = {};

        Object.values(attributes).forEach(
            ({ attribute_code, attribute_value }) => {
                if (attribute_code === 'color') {
                    search[attribute_code] = attribute_value;
                }
            }
        );

        return {
            pathname: parent_url || url,
            state: { product },
            search: objectToUri(search)
        };
    }

    onSearchEnterPress = (e) => {
        const {
            searchCriteria, hideActiveOverlay, onSearchBarChange, searchResults
        } = this.props;
        const search = searchCriteria.trim().replace(/\s/g, '+');
        const trimmedSearch = searchCriteria.trim();
        const customeUrl = this.getLinkTo();

        if (e.key === 'Enter' && trimmedSearch !== '') {
            if (searchResults.length === 1) {
                history.push(`${customeUrl.pathname}${customeUrl?.search}`);
            } else {
                history.push(appendWithStoreCode(`/search/${ search }`));
            }
            hideActiveOverlay();
            onSearchBarChange({ target: { value: '' } });
            this.searchBarRef.current.blur();
            this.closeSearch();
            scrollToTop();
        }
    };

    renderSearch() {
        const {
            searchCriteria, onSearchBarFocus, isActive, device
        } = this.props;

        return (
            <div block="SearchField" elem="SearchInnerWrapper">
                <input
                  id="search-field"
                  ref={ this.searchBarRef }
                  block="SearchField"
                  elem="Input"
                  onFocus={ onSearchBarFocus }
                  onChange={ this.handleChange }
                  onKeyDown={ this.onSearchEnterPress }
                  value={ searchCriteria }
                  mods={ { isActive } }
                  placeholder={ __('Welcome! Write what are you looking for...') }
                  autoComplete="off"
                  aria-label={ __('Search') }
                />
                { this.renderSearchIcon() }
                <Suspense fallback={ this.renderOverlayFallback() }>
                    <SearchOverlay
                      isHideOverlay={ !device.isMobile }
                      clearSearch={ this.clearSearch }
                      searchCriteria={ searchCriteria }
                    />
                </Suspense>
            </div>
        );
    }
}

export default SearchField;
